import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from './FadeIn';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft } = FiIcons;

const LegalLayout = ({ title, children }) => {
  return (
    <div className="min-h-screen bg-[#050c17]">
      {/* Top bar */}
      <div className="bg-navy border-b border-white/10 py-4 px-6">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="font-serif text-xl text-white font-bold hover:text-gold transition-colors">
            Der Dividenden-Investor
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 font-sans text-sm text-gray-400 hover:text-gold transition-colors"
          >
            <SafeIcon icon={FiArrowLeft} className="text-base" />
            Zurück
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-16">
        <FadeIn direction="up">
          <span className="font-sans text-gold text-xs tracking-widest uppercase mb-4 block">
            Rechtliches
          </span>
          <h1 className="font-serif text-4xl md:text-5xl text-white font-bold mb-6">{title}</h1>
          <div className="w-16 h-1 bg-gold mb-10"></div>
          <div className="font-sans text-gray-400 leading-relaxed space-y-6 text-sm">
            {children}
          </div>
        </FadeIn>
      </div>
    </div>
  );
};

export default LegalLayout;